export default __webpack_public_path__ + "static/media/gallery_04.023dc0b6.jpg";